import { cn } from '../../lib/utils';

type BadgeVariant = 'sage' | 'warning' | 'danger' | 'success' | 'neutral' | 'info' | 'purple';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const VARIANTS: Record<BadgeVariant, string> = {
  sage:    'bg-sage-light text-sage-dark border-[#c5d0c2]',
  warning: 'bg-accent-warning-bg text-accent-warning border-[#FDE68A]',
  danger:  'bg-accent-danger-bg text-accent-danger border-[#FECACA]',
  success: 'bg-accent-success-bg text-accent-success border-[#A7F3D0]',
  neutral: 'bg-stone-mid text-ink-mid border-stone-border',
  info:    'bg-accent-info-bg text-accent-info border-[#BAE6FD]',
  purple:  'bg-[#F5F3FF] text-[#7C3AED] border-[#DDD6FE]',
};

export default function Badge({ children, variant = 'neutral', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border whitespace-nowrap',
        VARIANTS[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
